module.exports = __webpack_public_path__ + "images/marketing/connect-screenshot4.jpg";